<template>
    <b-badge :variant="badgeVariant">
        {{ field }}
    </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "DataTypeBadge",
    components: {
        BBadge,
    },
    props: {
        field: {
            type: String,
            default: "string",
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        badgeVariant() {
            const badges = {
                string: "light-primary",
                number: "light-success",
                boolean: "light-secondary",
                json: "light-dark",
            };
            return badges[this.field] || "light-secondary";
        },
    },
};
</script>
